const LISTING_TYPES = {
  RENTAL: 'For Rent',
  ROOM: 'Room for Rent',
  SALE: 'For Sale',
};

const PROPERTY_TYPES = {
  COMMUNITY: 'Entire Apartment Community',
  CONDO: 'Condo / Apartment Unit',
  HOUSE: 'House',
  TOWNHOUSE: 'Townhouse',
};

const PropertyConstants = {
  LISTING_TYPES_BY_CODE: {
    1: LISTING_TYPES.RENTAL,
    2: LISTING_TYPES.SALE,
    5: LISTING_TYPES.ROOM,
  },
  PROPERTY_TYPES_BY_CODE: {
    1: PROPERTY_TYPES.COMMUNITY,
    2: PROPERTY_TYPES.COMMUNITY,
    3: PROPERTY_TYPES.COMMUNITY,
    5: PROPERTY_TYPES.CONDO,
    6: PROPERTY_TYPES.HOUSE,
    7: PROPERTY_TYPES.TOWNHOUSE,
  },
};

const postingUtils = {
  formatPriceFromApi(lowPrice, highPrice): string {
    if (typeof lowPrice === 'undefined') {
      return '';
    } else if (lowPrice !== highPrice) {
      return `${lowPrice}-${highPrice}`;
    }

    return lowPrice;
  },
  formatBedsFromApi(beds) {
    return beds >= 0 ? beds : '';
  },
  transformDatafromApi(apiData) {
    const dataFromApi = apiData;
    const listingType = PropertyConstants.LISTING_TYPES_BY_CODE[dataFromApi.listingType.code];
    const propertyType = PropertyConstants.PROPERTY_TYPES_BY_CODE[dataFromApi.propertyType.code];
    const apiFloorplans: any = [];

    dataFromApi.floorPlans?.forEach((floorplan) => {
      apiFloorplans.push({
        floorPlanId: floorplan.id,
        layoutPhoto: floorplan.layout || {},
        floorPlanPhotos: floorplan.floorPlanPhotos || [],
        price: this.formatPriceFromApi(floorplan.lowPrice, floorplan.highPrice) || '',
        securityDeposit: floorplan.securityDeposit,
        baths: floorplan.numBathrooms || '',
        beds: this.formatBedsFromApi(floorplan.numBedrooms),
        sqft: floorplan.squareFeet || '',
        dateAvailable: floorplan.dateAvailable || '',
        name: floorplan.name || '',
        unitAmenities: floorplan.unitAmenities || [],
      });
    });

    let buildingAttributes: any = null;
    let airConditioning = null;
    let furnished = null;
    let hardwoodFloors = null;
    if (dataFromApi.hasOwnProperty('buildingAttributes')) {
      buildingAttributes = dataFromApi.buildingAttributes;

      if (buildingAttributes.hasOwnProperty('airConditioningTypes')) {
        airConditioning = buildingAttributes.airConditioningTypes.hasAny;
      }

      if (buildingAttributes.hasOwnProperty('isFurnished')) {
        furnished = buildingAttributes.isFurnished;
      }

      if (buildingAttributes.hasOwnProperty('floorCoveringTypes')) {
        hardwoodFloors = buildingAttributes.floorCoveringTypes.hasHardwood;
      }
    }

    const newFormData = {
      active: dataFromApi.active,
      airConditioning: airConditioning !== null ? airConditioning : dataFromApi.airConditioning,
      amenities: dataFromApi.propertyAmenities,
      amenitiesText: '',
      apartmentAmenities: dataFromApi.apartmentAmenities,
      archived: dataFromApi.archived,
      canBeArchived: dataFromApi.canBeArchived,
      isApplicationsTogglePristine: dataFromApi.isApplicationsTogglePristine,
      applicationsAccepted: dataFromApi.applicationsAccepted,
      balconyOrDeck: dataFromApi.balconyDeckPatioPorch,
      buildingAttributes: dataFromApi.buildingAttributes,
      cats: dataFromApi.catsWelcome,
      ccToEmail: dataFromApi.email2,
      contactEmail: dataFromApi.email,
      contactFax: dataFromApi.fax,
      contactHours: {
        sunday: dataFromApi.contactHoursSunday,
        monday: dataFromApi.contactHoursMonday,
        tuesday: dataFromApi.contactHoursTuesday,
        wednesday: dataFromApi.contactHoursWednesday,
        thursday: dataFromApi.contactHoursThursday,
        friday: dataFromApi.contactHoursFriday,
        saturday: dataFromApi.contactHoursSaturday,
      },
      contactName: dataFromApi.contactName,
      contactPhone: dataFromApi.phone,
      city: dataFromApi.city,
      description: dataFromApi.fullDescription,
      feedId: dataFromApi.feedId,
      feedName: dataFromApi.feedName,
      floorplans: apiFloorplans,
      forRentBy: dataFromApi.forRentBy,
      furnished: furnished !== null ? furnished : dataFromApi.furnishedUnitsAvailable,
      garageParking: dataFromApi.garageParking,
      geo: dataFromApi.geo,
      hardwoodFloors: hardwoodFloors !== null ? hardwoodFloors : dataFromApi.hardwoodFloors,
      hideAddress: dataFromApi.hideStreetAddress,
      hidePhone: dataFromApi.hidePhone,
      isCommunity: dataFromApi.isCommunity,
      isConnectedExperience: dataFromApi.isConnectedExperience,
      isEditable: dataFromApi.isEditable,
      isPaidMultifamily: dataFromApi.isPaidMultifamily,
      isPaymentsEnabled: dataFromApi.isPaymentsEnabled,
      largeDogs: dataFromApi.largeDogsWelcome,
      laundry: dataFromApi.laundry,
      leaseDuration: dataFromApi.leaseDuration,
      leaseTerms: dataFromApi.leaseTerms,
      listingAlias: dataFromApi.listingAlias,
      listingId: dataFromApi.listingId,
      listingTitle: dataFromApi.name,
      listingType,
      listingTypeCode: dataFromApi.listingType.code,
      logo: dataFromApi.logo,
      numUnits: dataFromApi.numUnits,
      offStreetParking: dataFromApi.offStreetParking,
      permanent: dataFromApi.permanent,
      photos: dataFromApi.propertyPhotos,
      propertyTypeCode: dataFromApi.propertyType.code,
      propertyType,
      rentGuarantee: dataFromApi.rentGuarantee,
      rentZestimate: dataFromApi.rentZestimate,
      restrictions: dataFromApi.restrictions,
      schedule: dataFromApi.schedule,
      smallDogs: dataFromApi.smallDogsWelcome,
      specials: dataFromApi.previewMessage,
      specialOffers: dataFromApi.specialOffers,
      state: dataFromApi.state,
      street: dataFromApi.street,
      syndication: dataFromApi.syndication,
      unit: dataFromApi.unit,
      vaultware: dataFromApi.vaultware,
      vaultwarePropertyId: dataFromApi.vaultwarePropertyId,
      verified: !dataFromApi.needsPhoneVerification,
      webAnalytics: dataFromApi.webAnalytics,
      website: dataFromApi.website,
      wheelchairAccess: dataFromApi.wheelchairAccess,
      zip: dataFromApi.zip,
    };
    return newFormData;
  },
};

export default postingUtils;
